import Vue from 'vue';
import LoginApi from '../../api/LoginApi';
import phoneNumber from '../../utils/phoneNumber';

const loginFlowSteps = {
  enterPhone: 'enter-phone',
  enterCode: 'enter-code',
};

const errorTypes = {
  invalidPhoneNumber: 'INVALID_PHONE_NUMBER',
  cookiesDisabled: 'COOKIES_DISABLED',
  unknownError: 'UNKNOWN_ERROR',
  unMarkedError: 'UN_MARKED_ERROR',
};

const state = {
  phoneNumber: '',
  code: '',
  serverErrors: {
    generateCode: '',
    validateCode: '',
    loginAs: '',
  },
};

const getters = {
  loginFlowSteps: () => loginFlowSteps,
  phoneNumber: state => state.phoneNumber.replace(/\D/g, ''),
  errorTypes: () => errorTypes,
};

const actions = {
  async setCode({ commit }, code) {
    commit('setCode', { code });
  },
  async generateCode({ state, dispatch, commit }) {
    if (phoneNumber.validatePhoneNumber(state.phoneNumber)) {
      try {
        await LoginApi.generateCode({ phoneNumber: state.phoneNumber });
      } catch (e) {
        dispatch('catchServerError', { e, functionName: 'generateCode' });
      }
    } else {
      commit('setError', { error: errorTypes.invalidPhoneNumber, functionName: 'generateCode' });
      throw new Error('Invalid phone number');
    }
  },
  async validateCode({ commit, state, dispatch }, code) {
    commit('setCode', { code });
    try {
      await LoginApi.valideateCode({ phoneNumber: state.phoneNumber, code });
    } catch (e) {
      dispatch('catchServerError', { e, functionName: 'validateCode' });
    }
  },
  async loginAs({ dispatch }, customerToken) {
    try {
      await LoginApi.loginAs({ customerToken });
    } catch (e) {
      dispatch('catchServerError', { e, functionName: 'loginAs' });
    }
  },
  async logout({ dispatch }) {
    try {
      await LoginApi.logout();
    } catch (e) {
      dispatch('catchServerError', { e, functionName: 'logout' });
    }
  },
  catchServerError({ commit, state }, { e, functionName }) {
    if (e.response && e.response.status === 400) {
      commit('setError', { error: e.response.data, functionName });
    } else if (e.response && e.response.status === 409) {
      commit('setError', { error: errorTypes.cookiesDisabled, functionName });
    } else if (e.response && e.response.status === 403) {
      commit('setError', { error: errorTypes.unMarkedError, functionName });
    } else {
      commit('setError', { error: errorTypes.unknownError, functionName });
    }
    throw e;
  },
};

const mutations = {
  setPhoneNumber(state, phoneNumber) {
    state.phoneNumber = phoneNumber; // eslint-disable-line
  },
  setCode(state, { code }) {
    state.code = code; // eslint-disable-line
  },
  setError(state, { error, functionName }) {
    Vue.set(state.serverErrors, functionName, error);
  },
  resetError(state, functionName) {
    Vue.set(state.serverErrors, functionName, '');
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
